import React from 'react';
import { KeyField } from './ProviderToggle';

const savedPlaceholder = (masked: string | undefined, fallback: string) =>
  masked ? `已保存（尾号 ${masked}），输入新 Key 可替换` : fallback;

export const ApiKeyTabView: React.FC<{
  polloKey: string; setPolloKey: (v: string) => void;
  runningHubKey: string; setRunningHubKey: (v: string) => void;
  grsaiKey: string; setGrsaiKey: (v: string) => void;
  falKey: string; setFalKey: (v: string) => void;
  agnesKey: string; setAgnesKey: (v: string) => void;
  wavespeedKey: string; setWavespeedKey: (v: string) => void;
  replicateKey: string; setReplicateKey: (v: string) => void;
  savedMasked?: Record<string, string>;
}> = ({ polloKey, setPolloKey, runningHubKey, setRunningHubKey, grsaiKey, setGrsaiKey, falKey, setFalKey, agnesKey, setAgnesKey, wavespeedKey, setWavespeedKey, replicateKey, setReplicateKey, savedMasked = {} }) => (
  <div className="p-6 space-y-6">
    <KeyField
      label="Pollo.ai API Key (Wan 2.5)"
      value={polloKey} onChange={setPolloKey}
      placeholder={savedPlaceholder(savedMasked.pollo, '粘贴您的 Pollo API Key...')}
      description={<>用于激活 <strong>Wan 2.1 / Wan 2.5</strong> 视频生成模型。密钥提交后由服务端加密存储，页面仅显示尾号，不会回显明文。</>}
      provider="pollo" providerLabel="Pollo"
      linkHref="https://pollo.ai/dashboard/api-keys" linkText="获取 Key"
      prefix="key-" showBorder={false}
    />
    <KeyField
      label="RunningHub API Key (全能图片PRO)"
      value={runningHubKey} onChange={setRunningHubKey}
      placeholder={savedPlaceholder(savedMasked.runninghub, '粘贴您的 RunningHub API Key...')}
      description={<>用于激活 <strong>全能图片PRO</strong> 文生图/图生图模型。密钥提交后由服务端加密存储，页面仅显示尾号，不会回显明文。</>}
      provider="runninghub" providerLabel="RunningHub"
      linkHref="https://www.runninghub.cn" linkText="获取 Key"
    />
    <KeyField
      label="GRS AI API Key (GPT Image 2)"
      value={grsaiKey} onChange={setGrsaiKey}
      placeholder={savedPlaceholder(savedMasked.grsai, '粘贴您的 GRS AI API Key...')}
      description={<>用于激活 <strong>GPT Image 2</strong> 文生图/图生图模型。密钥提交后由服务端加密存储，页面仅显示尾号，不会回显明文。</>}
      provider="grsai" providerLabel="GRS AI"
      linkHref="https://grsai.ai/" linkText="获取 Key"
    />
    <KeyField
      label="fal.ai API Key (Kling 3.0)"
      value={falKey} onChange={setFalKey}
      placeholder={savedPlaceholder(savedMasked.fal, '粘贴您的 fal.ai API Key...')}
      description={<>用于激活 <strong>Kling 3.0</strong> 视频生成模型（标准版/专业版）。密钥提交后由服务端加密存储，页面仅显示尾号，不会回显明文。</>}
      provider="falai" providerLabel="fal.ai"
      linkHref="https://fal.ai/dashboard/keys" linkText="获取 Key"
    />
    <KeyField
      label="Agnes API Key (Agnes 2.0 Flash)"
      value={agnesKey} onChange={setAgnesKey}
      placeholder={savedPlaceholder(savedMasked.agnes, '粘贴您的 Agnes API Key...')}
      description={<>用于激活 <strong>Agnes 2.0 Flash</strong> 对话、<strong>Agnes Image 2.1 Flash</strong> 图片生成和 <strong>Agnes Video V2.0</strong> 视频生成模型。密钥提交后由服务端加密存储，页面仅显示尾号，不会回显明文。</>}
      provider="agnes" providerLabel="Agnes"
      linkHref="https://agnes-ai.com" linkText="获取 Key"
    />
    <KeyField
      label="WaveSpeed API Key (多角度相机)"
      value={wavespeedKey} onChange={setWavespeedKey}
      placeholder={savedPlaceholder(savedMasked.wavespeed, '粘贴您的 WaveSpeed API Key...')}
      description={<>用于激活 <strong>多角度相机</strong>（Qwen Image Edit 多角度视角）图生图模型。密钥提交后由服务端加密存储，页面仅显示尾号，不会回显明文。</>}
      provider="wavespeed" providerLabel="WaveSpeed"
      linkHref="https://wavespeed.ai" linkText="获取 Key"
    />
    <KeyField
      label="Replicate API Key (Topaz 高清放大)"
      value={replicateKey} onChange={setReplicateKey}
      placeholder={savedPlaceholder(savedMasked.replicate, '粘贴您的 Replicate API Token...')}
      description={<>用于激活 <strong>Topaz 高清放大</strong>（2x/4x/6x 超分，支持人脸修复）图生图模型。密钥提交后由服务端加密存储，页面仅显示尾号，不会回显明文。</>}
      provider="replicate" providerLabel="Replicate"
      linkHref="https://replicate.com/token" linkText="获取 Key"
    />
  </div>
);
